import { Box, Card } from "@mui/material";
import TruxSimpleTextField from "./inputs/trux-simple-text-field";

type SearchCardProps = {
  searchText: string,
  setSearchText: (a: string) => void,
  searchingFor: string,
  children?: React.ReactNode,
};

export function SearchCard({ searchText, setSearchText, searchingFor, children }: SearchCardProps) {
  return <Box sx={{ p: 0.5, pl: 0, gap: 1, display: "flex", mb: 2 }}>
    <Box sx={{ flex: 1 }}>
      <TruxSimpleTextField value={searchText} onChange={setSearchText} label={`Search ${searchingFor}`} />
    </Box>

    {children}

    <Box sx={{ flex: 2, display: { xs: "none", sm: "block" } }} />
  </Box>
}

export function SearchBox({ searchText, setSearchText, searchingFor }: SearchCardProps) {
  return <Box sx={{ p: 2, display: "flex", mb: 2 }}>
    <Box sx={{ flex: 1 }}>
      <TruxSimpleTextField value={searchText} onChange={setSearchText} label={`Search ${searchingFor}`} />
    </Box>

    <Box sx={{ flex: 2, display: { xs: "none", sm: "block" } }} />
  </Box>
}